module.exports = __webpack_public_path__ + "img/cast.90b6519e.svg";